const isTokenExpired = (token) => {try{let a = Date.now() >= (JSON.parse(atob(token.split('.')[1]))).exp * 1000; return a;}catch(e){return true;}};
var apiBaseURL = "https://oldapi.pdxplay.org";
var KTAPI = function(){

    const axios = window.Axios;

    axios.defaults.baseURL = apiBaseURL;
    axios.defaults.headers = { 
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept"
    }

    var getLogin = async function() {
        axios({
            url: "auth/steam",
            method: "get"
          })
          .then( (res) => {
            console.log(res.request.responseURL);
            //window.location = res.request.responseURL;        
          })
    }

    var login = async function() {
        try {
            const {data:response} = await axios({
                url: "auth/login",
                method: "post",
                headers: {'x-access-token': KTCookie.get('token'),'Content-Type': 'application/json'}
              }); //use data destructuring to get data from the promise object
            return response;
          }
    
        catch (error) {
            console.log(error);
        }
    }

    var logout = async function() {
        try {
            const {data:response} = await axios({
                url: "auth/logout",
                method: "post",
                headers: {'x-access-token': KTCookie.get('token'),'Content-Type': 'application/json'}
              }); //use data destructuring to get data from the promise object
            return response;
          }
    
        catch (error) {
            console.log(error);
        }
    }

    var checkAuth = async function() {
        try {
            const {data:response} = await axios({
                url: "auth/check",
                method: "post",
                headers: {'x-access-token': KTCookie.get('token'),'Content-Type': 'application/json'}
              }); //use data destructuring to get data from the promise object
            return response;
          }
    
        catch (error) {
            console.log(error);
        }
    }

    var getMe = async function() {        
        try {
            const {data:response} = await axios({
                url: "users/me",
                method: "get",
                headers: {'x-access-token': KTCookie.get('token')}
              }); //use data destructuring to get data from the promise object
            return response;
          }
    
        catch (error) {
            console.log(error);
        }
                  
    }

    var getUser = async function(info) {        
        try {
            const {data:response} = await axios({
                url: "users/getuser",
                method: "post",
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                            },
                data: info
              }); 
            return response;
          }
    
        catch (error) {
            console.log(error);
        }
                  
    }

    var getUserVisits = async function(info) {
        try {
            const {data:response} = await axios({
                url: `users/visits/${info}`,
                method: "get",
                headers: {
                    'x-access-token': KTCookie.get('token')}
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var getUserBans = async function(info) {
        try {
            const {data:response} = await axios({
                url: "users/getuserbans",
                method: "post",
                headers: {//'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                            },
                data: info
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }


    var getAkrosPlayers = async function() {
        try{
            const {data:response} = await axios({
                url: "akros/online",
                method: "get"
              });
            
            return response;              
        }
        catch (error) {
            console.log(error);
        }        
    }

    var getAkrosBans = async function() {
        try{
            const {data:response} = await axios({
                url: "akros/bans",
                method: "get"
              });
            
            return response;              
        }
        catch (error) {
            console.log(error);
        }        
    }


    var getFriends = async function(info) {        
        try {
            const {data:response} = await axios({
                url: "friends/",
                method: "post",
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                            },
                data: info
              }); 
            return response;
          }
    
        catch (error) {
            console.log(error);
        }
                  
    }

    var addFriend = async function(info) {        
        try {
            const {data:response} = await axios({
                url: "friends/add",
                method: "post",
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                data: info
              }); 
            return response;
          }
    
        catch (error) {
            console.log(error);
        }                  
    }

    var getSuggestions = async function(info) {
        try {
            const {data:response} = await axios({
                url: "friends/suggestions",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },                
              }); 
            return response;
          }
    
        catch (error) {
            console.log(error);
        }
    }    

    var searchFriends = async function(info) {
        try {
            const {data:response} = await axios({
                url: "friends/search",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },                
              }); 
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var getFriendRequests = async function(info) {
        try {
            const {data:response} = await axios({
                url: "friends/requests",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },                
              }); 
            return response;
          }
    
        catch (error) {
            console.log(error);
        }
    }

    var getFriendStatus = async function(info) {
        try {
            const {data:response} = await axios({
                url: "friends/friendstatus",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },                
              }); 
            return response;
          }
    
        catch (error) {
            console.log(error);
        }
    }

    var acceptFriend = async function(info) {
        try {
            const {data:response} = await axios({
                url: "friends/accept",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },                
              }); 
            return response;
          }
    
        catch (error) {
            console.log(error);
        }
    }

    var rejectFriend = async function(info) {
        try {
            const {data:response} = await axios({
                url: "friends/reject",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },                
              }); 
            return response;
          }
    
        catch (error) {
            console.log(error);
        }
    }

    var createMessage = async function(info) {
        try {
            const {data:response} = await axios({
                url: "message/create",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },                
                }); 
            return response;
            
        } catch (error) {
            console.log(error);
        }
    }

    var sendMessage = async function(info) {
        try {
            const {data:response} = await axios({
                url: "message/send",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },                
                }); 
            return response;
            
        } catch (error) {
            console.log(error);
        }
    }

    var getMessages = async function(info) {
        try {
            const {data:response} = await axios({
                url: "message/get",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },                
                }); 
            return response;
            
        } catch (error) {
            console.log(error);
        }
    }

    var checkThread = async function(info) {
        try {
            const {data:response} = await axios({
                url: "message/checkthread",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },                
                }); 
            return response;
            
        } catch (error) {
            console.log(error);
        }
    }

    //lobby
    var getLobbyList = async function() {
        try {
            const {data:response} = await axios({
                url: "lobby/getlist",
                method: "post",                
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },                
                }); 
            return response;
            
        } catch (error) {
            console.log(error);
        }
    }

    //lobby
    var getLocationPool = async function() {
        try {
            const {data:response} = await axios({
                url: "server/getlocpool",
                method: "get",                
                headers: {'x-access-token': KTCookie.get('token')}               
                }); 
            return response;
            
        } catch (error) {
            console.log(error);
        }
    }

    //lobby
    var getServerPool = async function() {
        try {
            const {data:response} = await axios({
                url: "server/getsvpool",
                method: "get",                
                headers: {'x-access-token': KTCookie.get('token')}               
                }); 
            return response;
            
        } catch (error) {
            console.log(error);
        }
    }
    var getMapPool = async function() {
        try {
            const {data:response} = await axios({
                url: "lobby/getmappool",
                method: "get",                
                headers: {'x-access-token': KTCookie.get('token')}               
                }); 
            return response;
            
        } catch (error) {
            console.log(error);
        }
    }

    //old system
    var getLocPool = async function() {
        try {
            const {data:response} = await axios({
                url: "stats/getlocpool",
                method: "get",                
                headers: {'x-access-token': KTCookie.get('token')}               
                }); 
            return response;
            
        } catch (error) {
            console.log(error);
        }
    }
    var getSvPool = async function() {
        try {
            const {data:response} = await axios({
                url: "stats/getserverpool",
                method: "get",                
                headers: {'x-access-token': KTCookie.get('token')}               
                }); 
            return response;
            
        } catch (error) {
            console.log(error);
        }
    }

    var getServers = async function(mode = null) {
        try {
            const {data:response} = await axios({
                url: mode == null || mode === undefined || mode == '' ? "stats/servers" : `stats/servers/${mode}`,
                method: "get",                
                headers: {'x-access-token': KTCookie.get('token')}
                }); 
            return response;
            
        } catch (error) {
            console.log(error);
        }
    }

    var getServer = async function(info) {
        try {
            const {data:response} = await axios({
                url: "stats/getserver",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },                
                }); 
            return response;
            
        } catch (error) {
            console.log(error);
        }
    }

    var getLiveStreamInfo = async function() {
        try {
            const {data:response} = await axios({
                url: "livestream/liveinfo",
                method: "get",                
                headers: {'x-access-token': KTCookie.get('token')}               
                }); 
            return response;
            
        } catch (error) {
            console.log(error);
        }
    }

    var getAllPlayers = async function(info) {
        try {
            const {data:response} = await axios({
                url: "players/",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },                
                }); 
            return response;
            
        } catch (error) {
            console.log(error);
        }
    }
    
    var getBestPlayersEachCountry = async function() {
        try {
            const {data:response} = await axios({
                url: "players/topcountry",
                method: "get",
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }                        

    var getPlayerStats = async function(info) {
        try {
            const {data:response} = await axios({
                url: "stats/player",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },                
                }); 
            return response;
            
        } catch (error) {
            console.log(error);
        }
    }

    var getPlayerMatches = async function(info) {
        try {
            const {data:response} = await axios({
                url: "stats/matches",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },                
                }); 
            return response;
            
        } catch (error) {
            console.log(error);
        }
    }

    var getPlayerRatingHistory = async function(info) {
        try {
            const {data:response} = await axios({
                url: "stats/ratinghistory",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var getPlayerWeapons = async function(info) {
        try {
            const {data:response} = await axios({
                url: "stats/playerweapons",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var getPlayerMaps = async function(info) {
        try {
            const {data:response} = await axios({
                url: "stats/playermaps",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var getPlayerBitches = async function(info) {
        try {
            const {data:response} = await axios({
                url: "stats/playerbitches",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var getFriendsWithStats = async function(info) {        
        try {
            const {data:response} = await axios({
                url: "friends/friendstats",
                method: "post",
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                            },
                data: info
              }); 
            return response;
          }
    
        catch (error) {
            console.log(error);
        }
                  
    }

    var getBans = async function(info) {
        try {
            const {data:response} = await axios({
                url: "stats/bans/",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                            },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var getUsersOnline = async function(info) {
        try{
            const {data:response} = await axios({
                url: "users/getonlineusers",
                method: "post",
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                            },
                });
            return response;
        } catch (error) {
            console.log(error);
        }

    }


    //settings
    var getMySettings = async function() {
        try {
            const {data:response} = await axios({
                url: "users/getsettings",
                method: "post",
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var updateMySettings = function(info, onProgress) {
        console.log("!",info);
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            /*let formData = new FormData();
            for (const key in info) {
                formData.append(key, info[key]);
            }*/
            let formData = info;

            xhr.open('POST', apiBaseURL+'/users/updatesettings');
            xhr.setRequestHeader('x-access-token', KTCookie.get('token'));
            //xhr.setRequestHeader('Content-Type', `application/x-www-form-urlencoded`);
        
            xhr.upload.addEventListener('progress', (event) => {
                if (event.lengthComputable) {
                    const percentComplete = (event.loaded / event.total) * 100;
                    onProgress(percentComplete);
                }
            });
        
            xhr.onreadystatechange = function() {
                if (xhr.readyState === 4) {
                    try {
                    if (xhr.status === 200) {
                        resolve(JSON.parse(xhr.responseText));
                    } else {
                        throw new Error(xhr.statusText);
                    }
                    } catch (error) {
                        reject(error);
                    }
                }
            };
        
            xhr.send(formData);
        });
    };

    var syncMySteam = async function() {
        try {
            const {data:response} = await axios({
                url: "users/syncsteam",
                method: "post",
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    };

    var getBotLink = async function() {
        try {
            const {data:response} = await axios({
                url: "users/getbotlink",
                method: "post",
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        }
        catch (error) {
            console.log(error);
        }
    };

    var isBotFriend = async function() {
        try {
            const {data:response} = await axios({
                url: "users/isbotfriend",
                method: "post",
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        }
        catch (error) {
            console.log(error);
        }
    };

    var verifyTS = async function() {
        try {
            const {data:response} = await axios({
                url: "users/teamspeak/verify",
                method: "post",
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        }
        catch (error) {
            console.log(error);
        }
    }; 
    
    var getTS = async function() {
        try {
            const {data:response} = await axios({
                url: "users/teamspeak/get",
                method: "get",
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        }
        catch (error) {
            console.log(error);
        }
    }


    //matches
    var getAllMatches = async function(info) {
        try {
            const {data:response} = await axios({
                url: "/match/matches",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    };

    var getMatchDetails = async function(info) {
        try {
            const {data:response} = await axios({
                url: "/match/matchdetails",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    };

    //leaders
    var getLeaderboard = async function(info) {
        try {
            const {data:response} = await axios({
                url: "/stats/leaderboard/",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    };

    //news
    var getNews = async function(info) {
        try {
            const {data:response} = await axios({
                url: "/news/getnews",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    };

    var getNew = async function(slug) {
        try {
            const {data:response} = await axios({
                url: `/news/${slug}`,
                method: "get",                
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    };

    var getNews = async function(info) {
        try {
            const {data:response} = await axios({
                url: "/news/getnews",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json' 
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }


    var postNews = async function(info) {
        try {
            const {data:response} = await axios({
                url: "/news/create/",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    };

    //toolbar

    var getToolbarData = async function() {
        try {
            const {data:response} = await axios({
                url: "/stats/toolbar/",
                method: "get",
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    };

    // globalchat

    var getGlobalChatHistory = async function(info) {
        try {
            const {data:response} = await axios({
                url: `message/global/history?limit=${info.limit}&page=${info.page}&lastMsgId=${info.lastMsgId || false}`,
                method: "get",                
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    };

    // social
    var getYotubeVideoInfo = async function(info) {
        try {
            let storedVideo = localStorage.getItem(info.videoId);
            if(storedVideo) {
                return JSON.parse(storedVideo);
            }

            const {data:response} = await axios({
                url: "/social/youtube/info",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            
            if(response.message !== "error") {
                localStorage.setItem(response.res.videoDetails.videoId, JSON.stringify(response));
            }

            
            return response;
        } catch (error) {
            console.log(error);
        }
    };

    var search = async function(info) {
        try {
            const {data:response} = await axios({
                url: "/search",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },                
              }); 
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var getRecentSearches = async function() {
        try {
            const {data:response} = await axios({
                url: "/search/recent",
                method: "get",
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },                
              }); 
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    //matchmaker
    var createParty = async function() {
        try {
            const {data:response} = await axios({
                url: "matchmaker/party/create",
                method: "post",
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },                
              }); 
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var getMyParty = async function() {
        try {
            const {data:response} = await axios({
                url: "matchmaker/party/getmy",
                method: "post",
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var joinParty = async function(info) {
        try {
            const {data:response} = await axios({
                url: "/matchmaker/party/join",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },                
              }); 
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var leaveParty = async function() {
        try {
            const {data:response} = await axios({
                url: "/matchmaker/party/leave",
                method: "post",
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },                
              }); 
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var kickParty = async function(info) {
        try {
            const {data:response} = await axios({
                url: "/matchmaker/party/kick",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },                
              }); 
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var sendChatToParty = async function(info) {
        try {
            const {data:response} = await axios({
                url: "/matchmaker/party/sendchat",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },                
              }); 
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var getPartyChatHistory = async function(info) {
        try {
            const {data:response} = await axios({
                //url: `/matchmaker/party/getchat?limit=${info.limit}&page=${info.page}&lastMsgId=${info.lastMsgId || false}`,
                url: `/matchmaker/party/getchat`,
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },                
              }); 
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var getPartyFriendsForInvite = async function() {
        try {
            const {data:response} = await axios({
                url: "/matchmaker/party/getfriendsforinvite",
                method: "post",
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var inviteToParty = async function(info) {
        try {
            const {data:response} = await axios({
                url: "/matchmaker/party/invite",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var acceptInvite = async function(info) {
        try {
            const {data:response} = await axios({
                url: "/matchmaker/party/acceptinvite",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var declineInvite = async function(info) {
        try {
            const {data:response} = await axios({
                url: "/matchmaker/party/declineinvite",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var editPartyName = async function(info) {
        try {
            const {data:response} = await axios({
                url: "/matchmaker/party/editname",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var joinQueue = async function(info) {
        try {
            const {data:response} = await axios({
                url: "/matchmaker/queue/join",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var leaveQueue = async function() {
        try {
            const {data:response} = await axios({
                url: "/matchmaker/queue/leave",
                method: "post",
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var confirmQueue = async function() {
        try {
            const {data:response} = await axios({
                url: "/matchmaker/queue/confirm",
                method: "post",
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var setSoloRegions = async function(info) {
        try {
            const {data:response} = await axios({
                url: "/matchmaker/queue/setregions",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var getQueueStatus = async function() {
        try {
            const {data:response} = await axios({
                url: "/matchmaker/queue/status",
                method: "get",
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var getQueueInfo = async function() {
        try {
            const {data:response} = await axios({
                url: "/matchmaker/queue/info",
                method: "get",
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var acceptQueue = async function(info) {
        try {
            const {data:response} = await axios({
                url: "/matchmaker/queue/accept",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var inQueue = async function() {
        try {
            const {data:response} = await axios({
                url: "/matchmaker/queue/isinqueue",
                method: "post",
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var quickMatchLogged = async function(info) {
        try {
            const {data:response} = await axios({
                url: "/matchmaker/quickmatchlogged",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var quickMatchNotLogged = async function(info) {
        try {
            const {data:response} = await axios({
                url: "/matchmaker/quickmatchnotlogged",
                method: "post",
                data: info,
                headers: {
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var getLobby = async function(info) {
        try {
            const {data:response} = await axios({
                url: `/matchmaker/lobby/${info}`,
                method: "get",                
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }

    var voteMap = async function(info) {
        try {
            const {data:response} = await axios({
                url: "/matchmaker/lobby/votemap",
                method: "post",
                data: info,
                headers: {
                            'x-access-token': KTCookie.get('token'),
                            'Content-Type': 'application/json'
                        },
                });
            return response;
        } catch (error) {
            console.log(error);
        }
    }        

    return{
        steamLogin: function() {
            getLogin();
        },
        logout: function() {
            return logout();
        },
        login: function() {
            return login();
        },
        checkAuth: function() {
            return checkAuth();
        },
        getMe: function() {
            //if(isTokenExpired(KTCookie.get('token'))) return {};
            return getMe();
        },
        getUser: function(info) {
            return getUser(info);
        },
        getUserBans: function(info) {
            return getUserBans(info);
        },
        getUserVisits: function(info) {
            return getUserVisits(info);
        },
        getAkrosBans: function(){
            return getAkrosBans();
        },
        getAkrosPlayers: function(){
            return getAkrosPlayers();
        },
        getFriends: function(info){
            return getFriends(info);
        },
        addFriend: function(info){
            return addFriend(info);
        },
        getSuggestions: function(info){
            return getSuggestions(info);
        },
        searchFriends: function(info){
            return searchFriends(info);
        },
        getFriendRequests: function(info){ 
            return getFriendRequests(info);
        },
        acceptFriend: function(info){
            return acceptFriend(info);
        },
        rejectFriend: function(info){
            return rejectFriend(info);
        },
        getFriendStatus: function(info){
            return getFriendStatus(info);
        },
        createMessage: function(info){
            return createMessage(info);
        },
        sendMessage: function(info){
            return sendMessage(info);
        },
        getMessages: function(info){
            return getMessages(info);
        },
        checkThread: function(info){
            return checkThread(info);
        },
        getLobbyList: function(){
            return getLobbyList();
        },
        getLocationPool: function(){
            return getLocationPool();
        },
        getServerPool: function(){
            return getServerPool();
        },
        getMapPool: function(){
            return getMapPool();
        },
        //oldsystem
        getLocPool: function(){
            return getLocPool();
        },
        getSvPool: function(){
            return getSvPool();
        },
        getServers: function(mode){
            return getServers(mode);
        },
        getServer: function(info){
            return getServer(info);
        },
    
        getLiveStreamInfo: function(){
            return getLiveStreamInfo();
        },
        //stats
        getAllPlayers: function(info){
            return getAllPlayers(info);
        },
        getBestPlayersEachCountry: function(){
            return getBestPlayersEachCountry();
        },
        getPlayerStats: function (info) {
            return getPlayerStats(info);
        },
        getPlayerMatches: function (info) {
            return getPlayerMatches(info);
        },
        getPlayerRatingHistory: function (info) {
            return getPlayerRatingHistory(info);
        },
        getPlayerWeapons: function (info) {
            return getPlayerWeapons(info);
        },
        getPlayerMaps: function (info) {
            return getPlayerMaps(info);
        },
        getPlayerBitches: function (info) {
            return getPlayerBitches(info);
        },
        getFriendsWithStats: function(info){
            return getFriendsWithStats(info);
        },
        getBans: function(info){
            return getBans(info);
        },

        //settings
        getMySettings: function(){
            return getMySettings();
        },  
        updateMySettings: function(info, callback){
            return updateMySettings(info, callback);
        },
        syncMySteam: function(){
            return syncMySteam();
        },

        getBotLink: function(){
            return getBotLink();
        },
        isBotFriend: function(){
            return isBotFriend();
        },
        verifyTS: function(){
            return verifyTS();
        },
        getTS: function(){
            return getTS();
        },

        //matches
        getAllMatches: function(info){ 
            return getAllMatches(info);
        },
        getMatchDetails: function(info){
            return getMatchDetails(info);
        },

        //leaders
        getLeaderboard: function(info){
            return getLeaderboard(info);
        },

        //news
        getNew: function(info){
            return getNew(info);
        },
        getNews: function(info){
            return getNews(info);
        },
        postNews: function(info){
            return postNews(info);
        },
        
        //toolbar
        getToolbarData: function(){
            return getToolbarData();
        },

        getUsersOnline: function(info){
            return getUsersOnline(info);
        },

        //globalchat
        getGlobalChatHistory: function(info){
            return getGlobalChatHistory(info);
        },

        //social
        getYotubeVideoInfo: function(info){
            return getYotubeVideoInfo(info);
        },

        //search
        search: function(info){
            return search(info);
        },
        getRecentSearches: function(){
            return getRecentSearches();
        },

        //matchmaker
        createParty: function(){
            return createParty();
        },
        getMyParty: function(){
            return getMyParty();
        },
        joinParty: function(info){
            return joinParty(info);
        },
        leaveParty: function(){
            return leaveParty();
        },
        kickParty: function(info){
            return kickParty(info);
        },
        sendChatToParty: function(info){
            return sendChatToParty(info);
        },
        getPartyChatHistory: function(info){
            return getPartyChatHistory(info);
        },
        getPartyFriendsForInvite: function(){
            return getPartyFriendsForInvite();
        },
        inviteToParty: function(info){
            return inviteToParty(info);
        },
        acceptInvite: function(info){
            return acceptInvite(info);
        },
        declineInvite: function(info){
            return declineInvite(info);
        },
        editPartyName: function(info){
            return editPartyName(info);
        },
        joinQueue: function(info){
            return joinQueue(info);
        },
        leaveQueue: function(){
            return leaveQueue();
        },
        confirmQueue: function(){
            return confirmQueue();
        },
        setSoloRegions: function(info){
            return setSoloRegions(info);
        },
        getQueueStatus: function(){
            return getQueueStatus();
        },
        getQueueInfo: function(){
            return getQueueInfo();
        },
        acceptQueue: function(info){
            return acceptQueue(info);
        },
        inQueue: function(){
            return inQueue();
        },
        quickMatchLogged: function(info){
            return quickMatchLogged(info);
        },
        quickMatchNotLogged: function(info){
            return quickMatchNotLogged(info);
        },
        getLobby: function(info){
            return getLobby(info);
        },
        voteMap: function(info){
            return voteMap(info);
        },

        me: {},
        user: {},
        
    };

}();

      



// Webpack support
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = KTAPI;
}